module.exports = "pegasus/assets/blocks/social-2-theme2.png";